/**
 * Konfigurasi console.log berdasarkan environment
 * Jika REACT_APP_ENV = development atau staging, tampilkan console.log
 * Selain itu, sembunyikan console.log
 */

const shouldShowConsole = () => {
  const env = process.env.REACT_APP_ENV;
  return env === "development" || env === "staging";
};

// Simpan referensi ke fungsi console.log asli
const originalConsoleLog = console.log;

// Override console.log berdasarkan environment
if (!shouldShowConsole()) {
  // Sembunyikan console.log jika bukan development atau staging
  console.log = () => {};
}

// Export untuk keperluan testing atau override manual jika diperlukan
export { originalConsoleLog, shouldShowConsole };
